<section role="region" aria-labelledby="h2Positions">
  <!-- Token: Positions -->
  <div class="sectionHeader" [ngClass]="{'hidden': !isMobile}">
    <h2 id="h2Positions">
      {{ 'k000129' | translate }}
    </h2>
  </div>
  <div>
<!-- Versión Desktop POSITIONS -->
<div *ngIf="!isMobile" class="flex-container-row card-white margen1">
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="loadingPositions; else showGrid"
  >
  </tech-loading-peq>
  <ng-template #showGrid>
    <dx-data-grid
      class="tech-table-info"
      [columns]="colsTrades"
      [dataSource]="dataPositions"
      [showColumnLines]="false"
      [showRowLines]="true"
      [showBorders]="false"
      [columnAutoWidth]="true"
      [wordWrapEnabled]="false"
      [focusedRowEnabled]="false"
      [paging]="false"
      [showColumnHeaders]="false"
      (onRowExpanded)="onRowExpanded($event)"
      (onRowCollapsing)="onRowCollapsing($event)"
      (onRowExpanding)="onRowExpanding($event)"
      hoverStateEnabled="false"
      (onRowClick)="onRowClick($event)"
      (onRowCollapsed)="onRowCollapsed($event)"
      (onCellPrepared)="onCellPrepared($event)"
    >
      <!--onRowCollapsing Cuando se esta haciendo el cierre-->
      <!--onRowExpanding Cuando se esta abriendo-->
      <dxo-selection mode="single"></dxo-selection>
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>
      <!--Para visualizar detalle dentro de la tabla -->
      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

      <!-- Plantillas para celdas con html en el masterdetail-->
      <div
        *dxTemplate="let el of 'detail'"
        class="detailswrapper opendetails_animation"
      >
        <!-- @slideDownUp-->
        <div class="details">
          <div class="title" *ngIf="investmentLab">
            <!-- Overview -->
            <span>{{ 'k003425' | translate }}</span>
          </div>
          <div class="tech-table-info-01 details">
            <div class="item">
              <span>{{ 'k000543' | translate }}</span
              ><span>
                {{ el.data.Valuation | trCurrency : el.data.ValuationCurrency }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k001809' | translate }}</span
              ><span>
                {{ el.data.CostValue | trCurrency : el.data.ValuationCurrency }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k000296' | translate }}</span>
              <span>
                {{
                  el.data.NumberOfShares
                    | trDouble
                      : (el.data.Behaviour === 'S' || el.data.Behaviour === '8'
                          ? '1.2-2'
                          : '1.6-6')
                }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k000048' | translate }}</span>
              <span
                *ngIf="
                  el.data.Behaviour === 'B' && el.data.QuotationType === 'N'
                "
              >
                {{ el.data.AssetPrice | trPercent }}
              </span>
              <span
                *ngIf="
                  el.data.Behaviour !== 'B' && el.data.QuotationType !== 'N'
                "
              >
                {{ el.data.AssetPrice | trCurrency : el.data.AssetCurrency }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k002871' | translate }}</span
              ><span>
                {{ el.data.AssetPriceDate | date : dateFormat }}
              </span>
            </div>

            <div class="item" *ngIf="el.data.Behaviour == 'B' && el.data.MaturityDate">
              <span>{{ 'k004198' | translate }}</span
              ><span>
                {{ el.data.MaturityDate | date : dateFormat }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k004197' | translate }}</span>
              <span>
                {{
                  el.data.UnrealizedGains
                    | trCurrencySignus : el.data.ValuationCurrency
                }}
                |
                {{ el.data.UnrealizedGainsPercent | trPercentSignus }}
              </span>
            </div>

            <div class="item">
              <span>{{ 'k001692' | translate }}</span
              ><span> {{ el.data.Weight | trPercent }} </span>
            </div>

            <div class="item" *ngIf="fieldISINClientPortal">
              <span>{{ 'k000159' | translate }}</span
              ><span> {{ el.data.Isin | trDashEmpty }} </span>
            </div>
          </div>
        </div>
        <!-- Show actions panel only if investmentLab is enabled -->
        <div class="details" *ngIf="investmentLab">
          <div class="title">
            <!-- Actions -->
            <span>{{ 'k003426' | translate }}</span>
          </div>
          <div class="container">
            <!-- Show asset TReport only if investmentLab is enabled -->
            <div class="item-A" *ngIf="investmentLab">
              <div class="card-img2">
                <button
                  mat-flat-button
                  tabindex="-1"
                  (click)="goTReport(el.data.Id)"
                >
                  <fa-icon class="imgs" [icon]="faFileChartLine"></fa-icon>
                </button>
              </div>
              <span>{{ 'k001387' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Plantillas para celdas con html-->
      <div *dxTemplate="let row of 'templateName'">
        <section class="tech-table-info-01 principal">
          <div class="info-A">
            <div class="logo-name {{ getColorById(row.row.data.Id) }}">
              {{ row.data.Name | uppercase | slice : 0 : 2 }}
            </div>
          </div>

          <div class="info-B">
            <p>{{ row.data.Name }}</p>
            <p>{{ row.data.AssetClassName }}</p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.Valuation | trCurrency : row.data.ValuationCurrency }}
            </div>
            <div>
              {{
                row.data.UnrealizedGains
                  | trCurrencySignus : row.data.ValuationCurrency
              }}
              |
              {{ row.data.UnrealizedGainsPercent | trPercentSignus }}
            </div>
          </div>
        </section>
      </div>
    </dx-data-grid>
  </ng-template>
</div>
<br *ngIf="dataPositionsCash.length > 0 && !isMobile" />
<div
  *ngIf="dataPositionsCash.length > 0 && !isMobile"
  class="flex-container-row card-white margen1"
>
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="loadingPositions; else showGrid"
  >
  </tech-loading-peq>
  <ng-template #showGrid>
    <dx-data-grid
      class="tech-table-info cash"
      [columns]="colsTrades"
      [dataSource]="dataPositionsCash"
      [showColumnLines]="false"
      [showRowLines]="true"
      [showBorders]="false"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="true"
      [paging]="false"
      [showColumnHeaders]="false"
      hoverStateEnabled="false"
    >
      <!--onRowCollapsing Cuando se esta haciendo el cierre-->
      <!--onRowExpanding Cuando se esta abriendo-->
      <dxo-selection mode="single"></dxo-selection>
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>
      <!--Para visualizar detalle dentro de la tabla -->
      <dxo-master-detail
        [enabled]="false"
        template="detail"
      ></dxo-master-detail>

      <!-- Plantillas para celdas con html en el masterdetail-->

      <!-- Plantillas para celdas con html-->
      <div *dxTemplate="let row of 'templateName'">
        <section class="tech-table-info-01 principal">
          <div class="info-A">
            <div class="logo-name cash">
              <fa-icon [icon]="['far', 'coins']"> </fa-icon>
            </div>
          </div>

          <div class="info-B">
            <p class="font-color">{{ row.data.Name }}</p>
            <p></p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.Valuation | trCurrency : row.data.ValuationCurrency }}
            </div>
            <div></div>
          </div>
        </section>
      </div>
    </dx-data-grid>
  </ng-template>
</div>

<!-- Versión Móvil POSITIONS -->
<div *ngIf="isMobile" class="flex-container-row card-white margen1">
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="loadingPositions; else showGrid"
  >
  </tech-loading-peq>
  <ng-template #showGrid>
    <dx-data-grid
      class="tech-table-info"
      [columns]="colsTrades"
      [dataSource]="dataPositions"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="true"
      [paging]="false"
      [showColumnHeaders]="false"
    >
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>

      <!-- Plantillas para celdas con html-->
      <div *dxTemplate="let row of 'templateMobile'">
        <div
          class="tech-table-info-01 principal"
          (click)="openDetailPosition(row.data)"
        >
          <div class="info-A">
            <div class="logo-name {{ getColorById(row.row.data.Id) }}">
              {{ row.data.Name | uppercase | slice : 0 : 2 }}
            </div>
          </div>

          <div class="info-B">
            <p>{{ row.data.Name }}</p>
            <p>{{ row.data.AssetClassName }}</p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.Valuation | trCurrency : row.data.ValuationCurrency }}
            </div>
            <div>
              {{
                row.data.UnrealizedGains
                  | trCurrencySignus : row.data.ValuationCurrency
              }}
              |
              {{ row.data.UnrealizedGainsPercent | trPercentSignus }}
            </div>
          </div>
        </div>
      </div>
    </dx-data-grid>
  </ng-template>
</div>
<br *ngIf="dataPositionsCash.length > 0 && isMobile" hidden/>
<div
  *ngIf="dataPositionsCash.length > 0 && isMobile"
  class="flex-container-row card-white margen1"
>
  <tech-loading-peq
    class="flex-container-row w-100"
    *ngIf="loadingPositions; else showGrid"
  >
  </tech-loading-peq>
  <ng-template #showGrid>
    <dx-data-grid
      class="tech-table-info"
      [columns]="colsTrades"
      [dataSource]="dataPositionsCash"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="true"
      [paging]="false"
      [showColumnHeaders]="false"
    >
      <!-- Desactiva cualquier tipo de ordenación-->
      <dxo-sorting mode="none"></dxo-sorting>

      <!-- Plantillas para celdas con html-->
      <div *dxTemplate="let row of 'templateMobile'">
        <div class="tech-table-info-01 principal">
          <div class="info-A">
            <div class="logo-name cash">
              <fa-icon [icon]="['fas', 'coins']"> </fa-icon>
            </div>
          </div>

          <div class="info-B">
            <p class="font-color">{{ row.data.Name }}</p>
            <p></p>
          </div>

          <div class="info-C">
            <div>
              {{ row.data.Valuation | trCurrency : row.data.ValuationCurrency }}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </dx-data-grid>
  </ng-template>
</div>

<ng-template #elseBlock>
  <div class="loading-spinner">
    <tech-loading-peq></tech-loading-peq>
  </div>
</ng-template>
  </div>
</section>
